// extracted by mini-css-extract-plugin
export default {"NavBack":"NavBack-module__NavBack--CBlT1","Container":"NavBack-module__Container--RdS8d","Link":"NavBack-module__Link--KLUOi"};